export enum ErrorLevel {
  WIDGET = 'WIDGET',
  PAGE = 'PAGE'
}
